module.exports = __webpack_public_path__ + "media/images/slider_h1_sp_05-38e5a690e494644ea5f59bafb27b8ead.png";